(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-products"] && !Shopify.designMode) return;
  try {
    (function() {
    // Store the click handler function reference to allow removal
    let refreshButtonClickHandler = null;
    let isRefreshing = false;

    // Helper function to extract URL from image (object or string)
    function getImageUrl(image) {
      if (!image) return null;
      if (typeof image === 'string') return image;
      if (typeof image === 'object' && image.src) return image.src;
      return null;
    }

    // Reusable function to refresh upsell item with a new product
    async function refreshUpsellItem(upsellItem) {
      // Prevent concurrent refresh operations
      if (isRefreshing) return;
      
      if (!upsellItem) {
        upsellItem = document.querySelector('.cart-upsell-item');
      }
      if (!upsellItem) return;
      
      isRefreshing = true;

      try {
        // Get current cart items to exclude
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        // Convert to numbers for accurate comparison
        const cartVariantIds = cart.items.map(item => parseInt(item.variant_id, 10));
        
        // Fetch all products
        const response = await fetch('/collections/all/products.json?limit=250');
        const data = await response.json();
        
        // Filter out products already in cart - compare as numbers for accuracy
        const availableProducts = data.products.filter(product => {
          const variantId = product.variants[0]?.id;
          if (!variantId) return false;
          const variantIdNum = parseInt(variantId, 10);
          return !cartVariantIds.includes(variantIdNum);
        });
        
        if (availableProducts.length > 0) {
          // Get random product
          const randomIndex = Math.floor(Math.random() * availableProducts.length);
          const randomProduct = availableProducts[randomIndex];
          const variant = randomProduct.variants[0];
          
          // Get product image URL
          let productImageUrl = null;
          if (randomProduct.featured_image) {
            productImageUrl = getImageUrl(randomProduct.featured_image);
          } else if (randomProduct.images && randomProduct.images.length > 0) {
            productImageUrl = getImageUrl(randomProduct.images[0]);
          } else if (variant && variant.featured_image) {
            productImageUrl = getImageUrl(variant.featured_image);
          }
          
          // Update checkbox data
          const checkbox = upsellItem.querySelector('.cart-upsell-checkbox');
          if (checkbox) {
            checkbox.dataset.variantId = variant.id;
            checkbox.dataset.productId = randomProduct.id;
            checkbox.checked = false;
            checkbox.disabled = false;
          }
          
          // Update product image
          const image = upsellItem.querySelector('.cart-upsell-product-image');
          if (image && productImageUrl) {
            let imageUrl = productImageUrl;
            
            // Convert to 100x100 size if Shopify CDN URL
            if (imageUrl && typeof imageUrl === 'string' && imageUrl.includes('cdn.shopify.com')) {
              const urlParts = imageUrl.split('?');
              let baseUrl = urlParts[0];
              const queryString = urlParts[1] || '';
              
              baseUrl = baseUrl.replace(/_(\d+)x(\d+)?\./g, '.');
              const extensionMatch = baseUrl.match(/\.(jpg|jpeg|png|webp|gif)$/i);
              if (extensionMatch) {
                baseUrl = baseUrl.replace(/\.(jpg|jpeg|png|webp|gif)$/i, '_100x100.$1');
              }
              imageUrl = queryString ? baseUrl + '?' + queryString : baseUrl;
            }
            
            image.alt = randomProduct.title || '';
            image.setAttribute('width', '100');
            image.setAttribute('height', '100');
            
            const oldSrc = image.src;
            if (oldSrc && oldSrc.split('?')[0] === imageUrl.split('?')[0]) {
              image.src = imageUrl + (imageUrl.includes('?') ? '&' : '?') + '_t=' + Date.now();
              setTimeout(() => {
                image.src = imageUrl;
              }, 100);
            } else {
              image.src = imageUrl;
            }
            
            image.onerror = function() {
              if (productImageUrl && productImageUrl !== imageUrl) {
                this.src = productImageUrl;
                this.onerror = null;
              } else if (randomProduct.images && randomProduct.images.length > 0) {
                const firstImage = getImageUrl(randomProduct.images[0]);
                if (firstImage) {
                  this.src = firstImage;
                  this.onerror = null;
                }
              }
            };
          }
          
          // Update product title
          const title = upsellItem.querySelector('.cart-upsell-title');
          if (title) {
            title.textContent = randomProduct.title;
          }
          
          // Update product price
          const price = upsellItem.querySelector('.cart-upsell-price');
          if (price && variant.price !== undefined && variant.price !== null) {
            let priceValue = variant.price;
            
            // Handle string prices (remove any formatting)
            if (typeof priceValue === 'string') {
              // Remove currency symbols and commas, keep numbers and decimal
              priceValue = priceValue.replace(/[^0-9.]/g, '');
              priceValue = parseFloat(priceValue);
            }
            
            priceValue = Number(priceValue);
            
            if (!isNaN(priceValue) && priceValue > 0) {
              // Check if price has decimal point
              const priceString = String(priceValue);
              const hasDecimal = priceString.includes('.');
              
              let priceInDollars;
              
              // If price has no decimal and is a reasonable dollar amount (< 10000), it's likely already in dollars
              // If price is >= 10000 or has no decimal and is large, it's likely in cents
              if (!hasDecimal && priceValue < 10000) {
                // Already in dollars, no conversion needed
                priceInDollars = priceValue;
              } else {
                // Likely in cents, divide by 100
                priceInDollars = priceValue / 100;
              }
              
              // Format as currency - always show 2 decimal places
              const formattedPrice = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }).format(priceInDollars);
              
              price.textContent = formattedPrice;
            }
          }
          
          // Update data attributes
          upsellItem.dataset.upsellProductId = variant.id;
          upsellItem.dataset.initialProductId = randomProduct.id;
        } else {
          // No available products - hide the upsell section only if it was visible
          // Don't hide on initial load if server-side already rendered it
          const upsellContainer = document.querySelector('.cart-upsell-container');
          if (upsellContainer && upsellContainer.style.display !== 'none') {
            hideUpsellSection();
          }
        }
      } catch (error) {
        // Silently handle errors
      } finally {
        // Reset refreshing flag
        isRefreshing = false;
      }
    }

    // Wait for DOM to be ready
    function initRefreshButton() {
      // Refresh button functionality
      const refreshButton = document.querySelector('.cart-upsell-refresh-button');
      
      if (!refreshButton) return;
      
      // Remove existing listener if it exists
      if (refreshButtonClickHandler) {
        refreshButton.removeEventListener('click', refreshButtonClickHandler);
        refreshButtonClickHandler = null;
      }
      
      // Create new click handler
      refreshButtonClickHandler = async function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // Prevent concurrent refresh operations
        if (isRefreshing) return;
        
        // Disable button while loading
        this.disabled = true;
        const svg = this.querySelector('svg');
        if (svg) {
          svg.style.animation = 'spin 1s linear infinite';
        }
        
        try {
          const upsellItem = document.querySelector('.cart-upsell-item');
          if (upsellItem) {
            await refreshUpsellItem(upsellItem);
          }
        } catch (error) {
          // Silently handle errors
        } finally {
          // Re-enable button
          this.disabled = false;
          if (svg) {
            svg.style.animation = '';
          }
        }
      };
      
      // Attach the listener
      refreshButton.addEventListener('click', refreshButtonClickHandler);
    }
    
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initRefreshButton);
    } else {
      initRefreshButton();
    }
    
    // Also try after a short delay in case the cart drawer loads dynamically
    setTimeout(initRefreshButton, 500);
    setTimeout(initRefreshButton, 1000);
    
    // Function to setup checkbox event listeners
    function setupUpsellCheckboxes() {
      const upsellCheckboxes = document.querySelectorAll('.cart-upsell-checkbox');
      
      upsellCheckboxes.forEach(checkbox => {
        // Skip if listener already attached
        if (checkbox.dataset.listenerAttached === 'true') return;
        checkbox.dataset.listenerAttached = 'true';
        
        // Prevent label click from closing drawer
        const label = checkbox.closest('.cart-upsell-checkbox-label');
        if (label && !label.dataset.clickHandlerAttached) {
          label.dataset.clickHandlerAttached = 'true';
          label.addEventListener('click', function(e) {
            // Only prevent if clicking on the label itself, not the checkbox
            if (e.target === label || label.contains(e.target)) {
              e.stopPropagation();
            }
          });
        }
        
        checkbox.addEventListener('change', async function(e) {
        // Prevent event from bubbling up (might close drawer)
        e.stopPropagation();
        e.preventDefault();
        
        if (this.checked) {
          const variantId = this.dataset.variantId;
          const productId = this.dataset.productId;
          const upsellItem = this.closest('.cart-upsell-item');
          const divider = document.querySelector('.cart-upsell-divider');
          const tbody = document.querySelector('.cart-items__table tbody');
          
          if (!variantId) {
            this.checked = false;
            return;
          }
          
          // Show loading state
          upsellItem.classList.add('cart-upsell-item--loading');
          const loadingElement = upsellItem.querySelector('.cart-upsell-loading');
          if (loadingElement) {
            loadingElement.style.display = 'flex';
          }
          
          // Disable checkbox while processing
          this.disabled = true;
          
          try {
            // Get the cart section ID for updating (same pattern as deletion)
            const cartItemsComponent = document.querySelector('cart-items-component');
            if (!cartItemsComponent) {
              this.checked = false;
              return;
            }
            
            const sectionId = cartItemsComponent.getAttribute('section-id') || 
                             cartItemsComponent.sectionId || 
                             'cart-items';
            
            // Get all cart items components to update all sections (same as deletion)
            const cartItemsComponents = document.querySelectorAll('cart-items-component');
            const sectionsToUpdate = new Set([sectionId]);
            cartItemsComponents.forEach((item) => {
              if (item instanceof HTMLElement && item.dataset.sectionId) {
                sectionsToUpdate.add(item.dataset.sectionId);
              }
            });
            
            // Disable cart items (same as deletion)
            if (cartItemsComponent.classList) {
              cartItemsComponent.classList.add('cart-items-disabled');
            }
            
            // Show shimmer on cart total (same as deletion)
            const cartTotal = cartItemsComponent.querySelector('[ref="cartTotal"]') || 
                             cartItemsComponent.querySelector('[data-cart-subtotal]');
            if (cartTotal && cartTotal.shimmer) {
              cartTotal.shimmer();
            }
            
            // Check if variant already exists in cart
            const currentCartResponse = await fetch('/cart.js');
            const currentCart = await currentCartResponse.json();
            const variantIdNum = parseInt(variantId, 10);
            const existingItem = currentCart.items.find(item => {
              // Compare both as numbers to ensure proper matching
              return parseInt(item.variant_id, 10) === variantIdNum;
            });
            
            let response;
            let addResponse;
            
            // If item exists, update it to quantity 1 directly (more reliable than remove + add)
            // If item doesn't exist, add it with quantity 1
            if (existingItem) {
              // Update existing item to quantity 1
              const updateFormData = new FormData();
              updateFormData.append('updates[' + existingItem.key + ']', '1');
              updateFormData.append('sections', Array.from(sectionsToUpdate).join(','));
              updateFormData.append('sections_url', window.location.pathname);
              
              response = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Accept': 'application/json',
                },
                body: updateFormData
              });
            } else {
              // Item doesn't exist, add it with quantity 1
              const formData = new FormData();
              formData.append('id', variantId);
              formData.append('quantity', '1');
              formData.append('sections', Array.from(sectionsToUpdate).join(','));
              formData.append('sections_url', window.location.pathname);
              
              response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Accept': 'application/json',
                },
                body: formData
              });
            }
            
            if (response && response.ok) {
              addResponse = await response.json();
              
              // Check for errors (same as deletion)
              if (addResponse && addResponse.status) {
                // Error occurred
                this.checked = false;
                if (cartTotal && cartTotal.resetShimmer) {
                  cartTotal.resetShimmer();
                }
                return;
              }
              
              // Get sections from response (works for both add.js and update.js)
              let sections = {};
              if (addResponse && addResponse.sections) {
                sections = addResponse.sections;
              } else {
                // Fallback: fetch sections if not in response
                try {
                  const sectionsResponse = await fetch(`/cart?section_id=${Array.from(sectionsToUpdate).join(',')}`);
                  if (sectionsResponse.ok) {
                    const sectionsText = await sectionsResponse.text();
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(sectionsText, 'text/html');
                    sectionsToUpdate.forEach(sid => {
                      const section = doc.querySelector(`#shopify-section-${sid}`) || 
                                     doc.querySelector(`[id*="${sid}"]`);
                      if (section) {
                        sections[sid] = section.outerHTML;
                      }
                    });
                  }
                } catch (e) {
                  // Ignore section fetch errors
                }
              }
              
              // Get updated cart data to verify quantity
              const cartResponse = await fetch('/cart.js');
              const cart = await cartResponse.json();
              
              // Verify and ensure quantity is 1 for the upsell item
              const addedItem = cart.items.find(item => {
                return parseInt(item.variant_id, 10) === variantIdNum;
              });
              
              // Double-check: if quantity is not 1, fix it (shouldn't happen with new logic, but safety check)
              if (addedItem && addedItem.quantity !== 1) {
                // If quantity is not 1, update it to 1
                const quantityFixFormData = new FormData();
                quantityFixFormData.append('updates[' + addedItem.key + ']', '1');
                quantityFixFormData.append('sections', Array.from(sectionsToUpdate).join(','));
                quantityFixFormData.append('sections_url', window.location.pathname);
                
                const quantityFixResponse = await fetch('/cart/update.js', {
                  method: 'POST',
                  headers: {
                    'Accept': 'application/json',
                  },
                  body: quantityFixFormData
                });
                
                if (quantityFixResponse.ok) {
                  const quantityFixResponseData = await quantityFixResponse.json();
                  // Update cart data with fixed quantity
                  if (quantityFixResponseData && quantityFixResponseData.items) {
                    cart.items = quantityFixResponseData.items;
                  }
                  // Update sections if provided - this is critical for UI update
                  if (quantityFixResponseData && quantityFixResponseData.sections) {
                    Object.assign(sections, quantityFixResponseData.sections);
                  } else {
                    // Fallback: fetch sections if not in response
                    try {
                      const sectionsResponse = await fetch(`/cart?section_id=${Array.from(sectionsToUpdate).join(',')}`);
                      if (sectionsResponse.ok) {
                        const sectionsText = await sectionsResponse.text();
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(sectionsText, 'text/html');
                        sectionsToUpdate.forEach(sid => {
                          const section = doc.querySelector(`#shopify-section-${sid}`) || 
                                         doc.querySelector(`[id*="${sid}"]`);
                          if (section) {
                            sections[sid] = section.outerHTML;
                          }
                        });
                      }
                    } catch (e) {
                      // Ignore section fetch errors
                    }
                  }
                }
              }
              
              // Reset shimmer (same as deletion)
              if (cartTotal && cartTotal.resetShimmer) {
                cartTotal.resetShimmer();
              }
              
              // Parse section HTML to get item count (same as deletion)
              let newCartItemCount = cart.item_count || 0;
              if (sections[sectionId]) {
                const newSectionHTML = new DOMParser().parseFromString(
                  sections[sectionId],
                  'text/html'
                );
                const newCartHiddenItemCount = newSectionHTML.querySelector('[ref="cartItemCount"]')?.textContent;
                if (newCartHiddenItemCount) {
                  newCartItemCount = parseInt(newCartHiddenItemCount, 10) || newCartItemCount;
                }
              }
              
              // Use morphSection to update (same as deletion)
              if (sections[sectionId] && typeof window.morphSection === 'function') {
                window.morphSection(sectionId, sections[sectionId]);
              }
              
              // Dispatch CartUpdateEvent (same format as deletion)
              if (typeof CartUpdateEvent !== 'undefined') {
                cartItemsComponent.dispatchEvent(
                  new CartUpdateEvent({}, sectionId, {
                    itemCount: newCartItemCount,
                    source: 'upsell-checkbox',
                    sections: sections,
                  })
                );
              } else {
                // Fallback: use CustomEvent
                document.dispatchEvent(new CustomEvent('cart:update', {
                  bubbles: true,
                  detail: {
                    resource: cart,
                    sourceId: sectionId,
                    data: {
                      itemCount: newCartItemCount,
                      source: 'upsell-checkbox',
                      sections: sections,
                    }
                  }
                }));
              }
              
              // Hide upsell section when item is added (per session)
              sessionStorage.setItem('upsellItemAdded', 'true');
              hideUpsellSection();
            } else {
              this.checked = false;
              if (cartTotal && cartTotal.resetShimmer) {
                cartTotal.resetShimmer();
              }
            }
          } catch (error) {
            this.checked = false;
            const cartItemsComponent = document.querySelector('cart-items-component');
            const cartTotal = cartItemsComponent?.querySelector('[ref="cartTotal"]') || 
                             cartItemsComponent?.querySelector('[data-cart-subtotal]');
            if (cartTotal && cartTotal.resetShimmer) {
              cartTotal.resetShimmer();
            }
          } finally {
            // Re-enable cart items (same as deletion)
            const cartItemsComponent = document.querySelector('cart-items-component');
            if (cartItemsComponent && cartItemsComponent.classList) {
              cartItemsComponent.classList.remove('cart-items-disabled');
            }
            
            // Hide loading state
            upsellItem.classList.remove('cart-upsell-item--loading');
            const loadingElement = upsellItem.querySelector('.cart-upsell-loading');
            if (loadingElement) {
              loadingElement.style.display = 'none';
            }
            this.disabled = false;
          }
        }
        });
      });
    }
    
    // Function to hide upsell section
    function hideUpsellSection() {
      const upsellDivider = document.querySelector('.cart-upsell-divider');
      const upsellContainer = document.querySelector('.cart-upsell-container');
      if (upsellDivider) {
        upsellDivider.style.display = 'none';
      }
      if (upsellContainer) {
        upsellContainer.style.display = 'none';
      }
    }
    
    // Function to show upsell section
    function showUpsellSection() {
      const upsellDivider = document.querySelector('.cart-upsell-divider');
      const upsellContainer = document.querySelector('.cart-upsell-container');
      if (upsellDivider) {
        upsellDivider.style.display = '';
      }
      if (upsellContainer) {
        upsellContainer.style.display = '';
      }
    }
    
    // Check sessionStorage on load and hide if upsell was added
    // Keep it hidden for the session after an item is added
    async function checkUpsellSession() {
      const upsellItemAdded = sessionStorage.getItem('upsellItemAdded');
      if (upsellItemAdded === 'true') {
        // Hide the upsell section if flag is set (item was added from upsell)
        hideUpsellSection();
        
        // Optionally: Clear the flag if cart is empty (so upsell can show again on fresh cart)
        try {
          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();
          
          // If cart is empty, clear the flag so upsell can show again
          if (!cart.items || cart.items.length === 0) {
            sessionStorage.removeItem('upsellItemAdded');
            showUpsellSection();
          }
        } catch (error) {
          // If check fails, keep it hidden (safer default)
        }
      } else {
        // No flag set, make sure upsell is visible
        showUpsellSection();
      }
    }
    
    // Setup checkboxes on page load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        setupUpsellCheckboxes();
        checkUpsellSession();
      });
    } else {
      setupUpsellCheckboxes();
      checkUpsellSession();
    }
    
    // Also setup after delays in case cart drawer loads dynamically
    setTimeout(function() {
      setupUpsellCheckboxes();
      checkUpsellSession();
    }, 500);
    setTimeout(function() {
      setupUpsellCheckboxes();
      checkUpsellSession();
    }, 1000);
    
    // Function to check if current upsell item is in cart and refresh if needed
    async function checkAndRefreshUpsellIfInCart() {
      const upsellItem = document.querySelector('.cart-upsell-item');
      if (!upsellItem) return;
      
      const checkbox = upsellItem.querySelector('.cart-upsell-checkbox');
      if (!checkbox || !checkbox.dataset.variantId) return;
      
      // Check if upsell section is hidden - if so, don't refresh
      const upsellContainer = document.querySelector('.cart-upsell-container');
      if (upsellContainer && upsellContainer.style.display === 'none') {
        return;
      }
      
      try {
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        const cartVariantIds = cart.items.map(item => parseInt(item.variant_id, 10));
        const upsellVariantId = parseInt(checkbox.dataset.variantId, 10);
        
        // If the current upsell item is in cart, refresh to show a different product
        if (cartVariantIds.includes(upsellVariantId)) {
          await refreshUpsellItem(upsellItem);
        }
      } catch (error) {
        // Silently handle errors
      }
    }
    
    // Re-initialize upsell functionality when cart updates (especially when cart goes from empty to having items)
    document.addEventListener('cart:update', function() {
      checkUpsellSession();
      // Check if current upsell item is in cart and refresh if needed
      checkAndRefreshUpsellIfInCart();
      // Re-initialize checkboxes and refresh button after cart section is updated
      setTimeout(function() {
        setupUpsellCheckboxes();
        initRefreshButton();
      }, 100);
      setTimeout(function() {
        setupUpsellCheckboxes();
        initRefreshButton();
      }, 500);
    });
    
    document.addEventListener('cart:updated', function() {
      checkUpsellSession();
      // Check if current upsell item is in cart and refresh if needed
      checkAndRefreshUpsellIfInCart();
      // Re-initialize checkboxes and refresh button after cart section is updated
      setTimeout(function() {
        setupUpsellCheckboxes();
        initRefreshButton();
      }, 100);
      setTimeout(function() {
        setupUpsellCheckboxes();
        initRefreshButton();
      }, 500);
    });
    
    // Re-setup checkboxes after upsell refresh (reset the flag so listener can be re-attached)
    const originalRefreshUpsellItem = refreshUpsellItem;
    refreshUpsellItem = async function(upsellItem) {
      await originalRefreshUpsellItem(upsellItem);
      // Reset listener flag so it can be re-attached
      const checkbox = upsellItem?.querySelector('.cart-upsell-checkbox');
      if (checkbox) {
        checkbox.dataset.listenerAttached = 'false';
      }
      setTimeout(() => {
        setupUpsellCheckboxes();
      }, 100);
    };
    
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-summary"] && !Shopify.designMode) return;
  try {
    // Hide Shop Pay buttons that cause CSP errors with shop.app
  (function() {
    function hideShopPayButtons() {
      const paymentButtonsContainer = document.querySelector('.cart__payment-buttons');
      if (!paymentButtonsContainer) return;

      // Find and hide Shop Pay buttons/iframes
      const shopPayElements = paymentButtonsContainer.querySelectorAll(
        'shopify-payment-button[data-shopify-payment-button], ' +
        'shopify-accelerated-checkout, ' +
        'iframe[src*="shop.app"], ' +
        'iframe[src*="shopify.com/shop-pay"], ' +
        '[data-shopify-button*="shop-pay"], ' +
        '[data-shopify-button*="shop_pay"]'
      );

      shopPayElements.forEach(element => {
        // Hide the parent container if it's a button wrapper
        const parent = element.closest('div[class*="shopify"], div[class*="payment"]');
        if (parent) {
          parent.style.display = 'none';
        } else {
          element.style.display = 'none';
        }
      });

      // Also check for buttons with Shop Pay text/attributes
      const allButtons = paymentButtonsContainer.querySelectorAll('button, a, div[role="button"]');
      allButtons.forEach(button => {
        const text = button.textContent?.toLowerCase() || '';
        const ariaLabel = button.getAttribute('aria-label')?.toLowerCase() || '';
        const dataAttr = button.getAttribute('data-shopify-button')?.toLowerCase() || '';
        
        if (text.includes('shop pay') || 
            text.includes('shopify pay') || 
            ariaLabel.includes('shop pay') ||
            dataAttr.includes('shop-pay') ||
            dataAttr.includes('shop_pay')) {
          const parent = button.closest('div[class*="shopify"], div[class*="payment"]');
          if (parent) {
            parent.style.display = 'none';
          } else {
            button.style.display = 'none';
          }
        }
      });
    }

    // Run immediately
    hideShopPayButtons();

    // Run after DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', hideShopPayButtons);
    }

    // Run after a delay to catch dynamically loaded buttons
    setTimeout(hideShopPayButtons, 500);
    setTimeout(hideShopPayButtons, 1000);
    setTimeout(hideShopPayButtons, 2000);

    // Use MutationObserver to watch for dynamically added buttons
    const observer = new MutationObserver(function(mutations) {
      let shouldCheck = false;
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
          shouldCheck = true;
        }
      });
      if (shouldCheck) {
        hideShopPayButtons();
      }
    });

    // Observe the payment buttons container
    const paymentButtonsContainer = document.querySelector('.cart__payment-buttons');
    if (paymentButtonsContainer) {
      observer.observe(paymentButtonsContainer, {
        childList: true,
        subtree: true
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
